import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// The phone field's layout half — see the "Phone field" block in globals.css
// for the theming half. Imported BEFORE globals.css so the app's overrides win
// without needing !important.
import 'react-phone-number-input/style.css';
import './styles/globals.css';
import { gaMeasurementId } from './config/environment';
import { startAnalytics } from './utils/analytics';

// No service worker registration. The copied client cached the app shell and
// prompted for a refresh on every update; against an API whose data changes
// under you, a cached shell mostly serves stale code during development. If the
// Academy ever needs to be installable, register one here deliberately — with a
// versioning strategy — rather than inheriting it.

startAnalytics(gaMeasurementId);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
